(function () {
  var WORKER_URL = 'https://afw-lounge-size-sync.afw-costa.workers.dev/popup-signup';
  var STORAGE_KEY = 'afw_popup_seen';
  var CODE_ISSUED_KEY = 'afw_popup_code_issued';
  var DELAY_MS = 20000;

  var root = document.getElementById('afwWelcomePopup');
  if (!root) return;

  var tab = document.querySelector('[data-afw-popup-tab]');
  var TAB_DELAY_MS = 2000;

  function alreadySeen() {
    try { return !!localStorage.getItem(STORAGE_KEY); } catch (e) { return false; }
  }
  function markSeen() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }
  // Separate from alreadySeen: a mere dismissal ("No thanks" / the X) only suppresses the
  // auto-popup/exit-intent for this session - the corner tab stays available as a standing
  // offer so someone who closed it by mistake or changed their mind can still get to it.
  // Only an actual issued code retires the tab for good, since re-offering "$25 off" to
  // someone who already has a code would be pointless.
  function hasCode() {
    try { return !!localStorage.getItem(CODE_ISSUED_KEY); } catch (e) { return false; }
  }
  function markCodeIssued() {
    try { localStorage.setItem(CODE_ISSUED_KEY, '1'); } catch (e) {}
  }

  function hideTab() { if (tab) tab.classList.remove('is-visible'); }
  function showTabIfEligible() { if (tab && !hasCode()) tab.classList.add('is-visible'); }
  if (tab && !hasCode()) setTimeout(showTabIfEligible, TAB_DELAY_MS);

  function show() {
    if (alreadySeen()) return;
    root.hidden = false;
    hideTab();
    document.removeEventListener('mouseout', onExitIntent);
    clearTimeout(timer);
  }
  function hide() {
    root.hidden = true;
    markSeen();
    showTabIfEligible();
  }

  function onExitIntent(e) {
    if (e.clientY > 40) return;
    if (e.relatedTarget || e.toElement) return;
    show();
  }

  var timer = setTimeout(show, DELAY_MS);
  document.addEventListener('mouseout', onExitIntent);
  function forceShow() {
    root.hidden = false;
    hideTab();
    document.removeEventListener('mouseout', onExitIntent);
    clearTimeout(timer);
  }
  window.afwOpenWelcomePopup = forceShow;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-afw-popup-trigger]')) { e.preventDefault(); forceShow(); }
  });

  root.querySelectorAll('[data-afw-popup-close]').forEach(function (el) {
    el.addEventListener('click', hide);
  });

  var form = root.querySelector('[data-afw-popup-form]');
  var errorEl = root.querySelector('[data-afw-popup-error]');
  var submitBtn = form.querySelector('.afw-popup-submit');
  var submitText = form.querySelector('[data-afw-popup-submit-text]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = root.querySelector('#afwPopupEmail').value.trim();
    errorEl.hidden = true;
    if (!email || email.indexOf('@') === -1) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.hidden = false;
      return;
    }

    submitBtn.disabled = true;
    submitText.textContent = 'Getting your code...';

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data && result.data.error ? result.data.error : 'Something went wrong.');
        }
        if (result.data.alreadyOnList) {
          errorEl.textContent = 'You already have an account with this email. Sign in to see your details.';
          errorEl.hidden = false;
          root.querySelector('[data-afw-popup-signin]').hidden = false;
          return;
        }
        root.querySelector('[data-afw-popup-code]').textContent = result.data.code;
        root.querySelector('[data-afw-popup-step="form"]').hidden = true;
        root.querySelector('[data-afw-popup-step="success"]').hidden = false;
        markSeen();
        markCodeIssued();
      })
      .catch(function (err) {
        errorEl.textContent = err.message || 'Something went wrong. Please try again.';
        errorEl.hidden = false;
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitText.textContent = 'Get my $25 code';
      });
  });

  var copyBtn = root.querySelector('[data-afw-popup-copy]');
  copyBtn.addEventListener('click', function () {
    var code = root.querySelector('[data-afw-popup-code]').textContent;
    var done = function () {
      var original = copyBtn.textContent;
      copyBtn.textContent = 'Copied!';
      setTimeout(function () { copyBtn.textContent = original; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      done();
    }
  });
})();
